module.exports = __webpack_public_path__ + "media/assets/community/badge-osc-teacher-a68f8bc204173c98e663678ed7f97cbe9f13de00ff342eb74af32a4902a9434b.png";